import { IProcessReference } from '@/Domain/interfaces/Process/IProcessReference';
import Tab from './Tab';

export default class TabCalification extends Tab {
    private _pendingTiebreakers: number;
    private _totalQualifiedInscriptions: number;
    private _totalTiebreakers: number;
    private _vacancies: number;
    private _references: IProcessReference[];

    constructor(data: any) {
        super(data.type);
        this._pendingTiebreakers = data.pendingTiebreakers;
        this._totalQualifiedInscriptions = data.totalQualifiedInscriptions;
        this._totalTiebreakers = data.totalTiebreakers;
        this._vacancies = data.vacancies;
        this._references = data.references || [];

    }

    public get pendingTiebreakers() {
        return this._pendingTiebreakers;
    }
    public set pendingTiebreakers(pendingTiebreakers: number) {
        this._pendingTiebreakers = pendingTiebreakers;
    }

    public get totalQualifiedInscriptions() {
        return this._totalQualifiedInscriptions;
    }
    public set totalQualifiedInscriptions(totalQualifiedInscriptions: number) {
        this._totalQualifiedInscriptions = totalQualifiedInscriptions;
    }

    public get totalTiebreakers() {
        return this._totalTiebreakers;
    }
    public set totalTiebreakers(totalTiebreakers: number) {
        this._totalTiebreakers = totalTiebreakers;
    }

    public get vacancies() {
        return this._vacancies;
    }
    public set vacancies(vacancies: number) {
        this._vacancies = vacancies;
    }

    public get references() {
        return this._references;
    }
    public set references(references: IProcessReference[]) {
        this._references = references;
    }
}
